const association = {
  // HeroSection
  'association.hero.homeLink': 'ホーム',
  'association.hero.aboutLink': 'アカデミーについて',
  'association.hero.currentPage': '全日本執事協会について',
  'association.hero.title': '全日本執事協会について',
  'association.hero.titleEn': 'THE ASSOCIATION',
  'association.hero.lead': '日本執事アカデミーは、一般社団法人全日本執事協会が運営しています。協会の創立は1890年（明治23年）、法人としての設立は2025年2月19日です。協会は日本の執事文化を伝える執事学校として、体系的なバトラー養成を担う運営母体です。',
  'association.hero.imgAlt': '重厚な扉と装飾を備えた応接室で執事が佇む格式ある室内の様子',
  'association.role.imgAlt': '協会が発行する認定証とピンバッジのイメージ',

  // AssociationRole
  'association.role.label': 'OUR ROLE',
  'association.role.title': '全日本執事協会はどんな団体？',
  'association.role.subtitleEn': 'What is the Japan Butler Association?',
  'association.role.sub1': '運営母体・全日本執事協会',
  'association.role.sub2': '育成・認定・キャリア支援',
  'association.role.sub3': '法人研修と認定資格の区別',
  'association.role.para1': '日本執事アカデミーの運営母体は、一般社団法人全日本執事協会です。協会は、執事の育成と認定、そして企業向けの研修を通じて、日本における執事文化の確立に取り組んでいます。',
  'association.role.para2': '協会の活動は、単に執事を養成するだけではありません。育成した人材の質を保証する認定資格の発行、執事の接遇スキルを企業の現場に活かす法人研修の提供、そして修了生のキャリア形成を支援する仕組みの整備——これらを一貫して担うことで、執事という職業の社会的な価値を高めることを目指しています。日本の執事学校として、日本で通用する執事資格の認定を通じてその質を社会に示しています。',
  'association.role.para3': 'なお、法人研修で提供するのは執事の接遇スキルに基づくビジネスマナー教育であり、企業の受講者に執事資格を付与するものではありません。本科課程の協会認定資格とは区別してご理解ください。今後の事業展開については、検討が整い次第、順次公開してまいります。',

  // AssociationServices
  'association.services.label': 'WHAT WE OFFER',
  'association.services.title': '協会が提供するもの',
  'association.services.subtitleEn': 'Services of the Association',
  'association.services.lead': '協会が担う役割は、大きく四つに分かれます。執事を育てる本科、学びを証明する認定資格、企業の現場を支える法人研修、そして修了生のキャリアを支援する仕組みの整備です。',
  'association.services.viewLink': '詳しく見る',
  'association.services.1.title': '執事育成（本科3コース）',
  'association.services.1.desc': 'エッセンシャル・アドバンス・マスターの3段階で、基礎から管理・危機対応までを体系立てて指導します。定員6名の完全少人数制・土日開催。',
  'association.services.2.title': '協会認定資格の認定',
  'association.services.2.desc': '所定の課程を修了し、実技試験に合格した方に、全日本執事協会認定のバトラー資格を授与します。協会が定める基準に達した証です。',
  'association.services.3.title': '法人研修（接遇・ビジネスマナー）',
  'association.services.3.desc': '執事の接遇スキルに基づく法人向け研修を提供します。出張または来校にて、貴社の現場に合わせたプログラムを設計します。',
  'association.services.4.title': '修了生へのキャリア支援（準備中）',
  'association.services.4.desc': '修了生の方へ、協会が把握した執事関連の求人情報を提供する仕組みを予定しています。キャリア形成の選択肢のひとつとしてご活用いただけるよう準備を進めています。',

  // AssociationTable
  'association.table.label': 'ORGANIZATION',
  'association.table.title': '協会概要',
  'association.table.subtitleEn': 'Association Overview',
  'association.table.label1': '名称',
  'association.table.value1': '一般社団法人全日本執事協会',
  'association.table.label2': '所在地',
  'association.table.value2': '〒135-0064 東京都江東区青海2丁目7-4（お台場）',
  'association.table.label3': '電話',
  'association.table.value3': '03-6824-4086（受付 平日10:00〜17:00）',
  'association.table.label4': 'メール',
  'association.table.value4': 'info@butler-academy.jp',
  'association.table.label5': '事業内容',
  'association.table.value5': '執事の育成、認定資格の認定、法人研修、修了生向けキャリア支援（準備中）',
  'association.table.label6': '代表者',
  'association.table.value6': '代表理事 石井裕一（執事ベル／三代目頭取）',
  'association.table.label7': '創立',
  'association.table.value7': '1890年（明治23年）',
  'association.table.label8': '法人設立',
  'association.table.value8': '2025年2月19日（一般社団法人全日本執事協会）',

  // ContactGuide
  'association.contact.label': 'CONTACT',
  'association.contact.title': 'お問い合わせ',
  'association.contact.subtitleEn': 'Get in Touch',
  'association.contact.body': '協会へのご質問や取材のお申し込みは、お問い合わせフォームより承ります。資料請求は無料でお送りしています。',
  'association.contact.ctaContact': 'お問い合わせ',
  'association.contact.ctaBrochure': '資料請求はこちら（無料）',

  // FAQ
  'association.faq.label': 'FAQ',
  'association.faq.title': 'よくあるご質問',
  'association.faq.subtitleEn': 'Frequently Asked Questions',
  'association.faq.footer': 'その他のご質問はお問い合わせフォームよりお寄せください',
  'association.faq.q1': '協会は何をしている団体ですか？',
  'association.faq.a1': '執事の育成（本アカデミーの運営）、協会認定資格の認定、企業向けの接遇・ビジネスマナー研修、修了生向けキャリア支援（準備中）を行っています。',
  'association.faq.q2': '認定資格は国家資格ですか？',
  'association.faq.a2': 'いいえ。協会が独自に認定する民間資格です。修了実技試験の合格者に授与しています。',
  'association.faq.q3': '法人向けの研修も依頼できますか？',
  'association.faq.a3': 'はい。執事の接遇スキルに基づくビジネスマナー研修を、出張・来校いずれの形式でも承っています。法人研修のページをご覧ください。',

  // CTA
  'association.cta.label': 'TAKE THE NEXT STEP',
  'association.cta.title': 'まずはお気軽にどうぞ',
  'association.cta.body': 'コース、認定資格、法人研修——いずれについてもご不明な点がございましたらお気軽にお問い合わせください。',
  'association.cta.note': '※ご相談はオンラインでも承ります',
  'association.cta.courses': 'コースを見る',
  'association.cta.corporate': '法人研修を見る',

  // RelatedPages
  'association.related.title': '関連ページ',
  'association.related.subtitleEn': 'Explore Further',
  'association.related.viewLink': '詳しく見る',
  'association.related.backLink': 'アカデミーについての総合ページへ戻る',
  'association.related.link0.title': 'アカデミーについて',
  'association.related.link0.desc': 'アカデミーの全体像',
  'association.related.link1.title': '修了証・認定資格について',
  'association.related.link1.desc': '修了で得られる協会認定資格',
  'association.related.link2.title': '法人研修',
  'association.related.link2.desc': '企業向けの接遇・ビジネスマナー研修',
  'association.related.link3.title': 'お問い合わせ',
  'association.related.link3.desc': 'ご質問・ご相談の窓口',
  'association.related.link4.title': '学長挨拶',
  'association.related.link4.desc': '学長・執事ベルからのメッセージ',
  'association.related.link5.title': '全日本執事協会 事業紹介',
  'association.related.link5.desc': '協会が提供する事業の詳しいご紹介',

  // Last updated
  'association.lastUpdated': '最終更新: 2026年7月8日',
};

export default association;
